// src/features/agent-builder/components/AITestGeneratorButtonTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

export const AITestGeneratorButtonTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');
  const buttonAriaLabel = t('step3.aiTestGenerator.buttonAriaLabel');

  return (
    <Tooltip
      textKey="agentBuilder:step3.aiTestGenerator.tooltip"
    >
      <IconButton
        icon={renderIcon('flask', { size: 16 })} // Using your renderIcon utility
        ariaLabel={buttonAriaLabel}
        variant="ghost" // Relies on IconButton's Neobrutalist styling for ghost variant
        size="sm"
        disabled // Key for teaser state
        className="opacity-70 cursor-not-allowed text-purple-600 hover:text-purple-700 focus-visible:ring-purple-500"
        // NB: The focus-visible:ring-purple-500 is specific.
        // If global standard is emerald, this should be:
        // className="opacity-70 cursor-not-allowed text-purple-600 hover:text-purple-700 focus-visible:ring-emerald-500 focus-visible:ring-offset-1"
        // Assuming IconButton applies its own base focus styling correctly.
      />
    </Tooltip>
  );
};